
export const StaffCreate = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Create Staff</h1>
      </div>
      <div className="bg-white p-6 rounded-lg shadow max-w-2xl">
        <p className="text-gray-500">Create staff form</p>
      </div>
    </div>
  );
};
